import {IDroneFlightModel} from "../../../api/bhp/geomeasurement/DroneFlight/IDroneFlightModel";
import dayjs from "dayjs";

export const getHourRangeLabel = (droneFlight: IDroneFlightModel) => {
    return `${dayjs(droneFlight.fromDate).format('HH:mm')} - ${dayjs(droneFlight.toDate).format('HH:mm')}`
}

export const getDateLabel = (droneFlight: IDroneFlightModel) => {
    return `${dayjs(droneFlight.fromDate).format('DD/MM/YYYY')}`
}